import validator from './validator'
import { FIELD_RULES } from '../constants'
import { every, constant, isEmpty, forEach } from 'lodash'

const { ASYNC } = FIELD_RULES

const validateField = (field, fields) => {
  const errors = []
  const { rules } = field
  const isAsync = Boolean((rules || []).find(({ type }) => type === ASYNC))

  forEach(rules, (rule) => {
    const { type, ruleOption } = rule
    const isValid = (validator[type] || constant(true))(
      field,
      fields,
      ruleOption
    )

    if (!isValid) {
      errors.push(rule)
    }
  })

  /* Do not trigger async validation if
  // a) it has no async rule
  // b) it has sync errors
   */
  if (!isAsync || errors.length) {
    return {
      shouldValidateAsync: false,
      errors
    }
  }

  return {
    shouldValidateAsync: true,
    errors
  }
}

export const areFieldsLoadedAndValid = (fields) => {
  return Boolean(
    every(fields, ({ errors, isLoading }) => isEmpty(errors) && !isLoading)
  )
}

export default validateField
